import { useState } from 'react'
import { useMatches } from '../hooks/useMatches'
import MatchCard from './MatchCard'

export default function HistoryPage({ onMatchSelect }) {
  const { data: matches, isLoading } = useMatches()
  const [showAll, setShowAll] = useState(false)

  const completedMatches = matches?.filter((m) => m.status === 'completed').sort((a, b) => new Date(b.created_at) - new Date(a.created_at)) || []
  const displayedMatches = showAll ? completedMatches : completedMatches.slice(0, 10)

  return (
    <div>
      <h3 style={{
        fontSize: '0.75rem',
        fontWeight: '600',
        color: 'var(--text-muted)',
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
        marginBottom: '0.75rem',
      }}>
        Completed
      </h3>

      {isLoading ? (
        <p style={{ color: 'var(--text-muted)', textAlign: 'center', padding: '2rem' }}>
          Loading...
        </p>
      ) : completedMatches.length === 0 ? (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '30vh',
          gap: '1rem',
          textAlign: 'center',
        }}>
          <div style={{
            width: '80px',
            height: '80px',
            borderRadius: '50%',
            backgroundColor: 'var(--bg-tertiary)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <span style={{ fontSize: '2rem' }}>🏆</span>
          </div>
          <p style={{ color: 'var(--text-secondary)', fontSize: '0.875rem' }}>
            No completed events yet.
          </p>
        </div>
      ) : (
        <>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
            {displayedMatches.map((match) => (
              <MatchCard key={match.id} match={match} onClick={() => onMatchSelect(match.id)} />
            ))}
          </div>
          {!showAll && completedMatches.length > 10 && (
            <button
              onClick={() => setShowAll(true)}
              style={{
                width: '100%',
                marginTop: '0.75rem',
                padding: '0.625rem',
                borderRadius: '9999px',
                fontSize: '0.8125rem',
                fontWeight: '600',
                color: 'var(--accent-primary)',
                backgroundColor: 'transparent',
                border: '1px solid var(--border-color)',
              }}
            >
              Show All ({completedMatches.length})
            </button>
          )}
        </>
      )}
    </div>
  )
}
